import React, { Component } from "react";
import CloseIcon from "@material-ui/icons/Close";
import { connect } from "react-redux";
import { SwipeableDrawer, Drawer } from "@material-ui/core";
import Password from "./Password";
import instance from "../../../store/actions/instance";
import Profile from "./Profile";

class B2BProfile extends Component {
  state = {
    password: "",
    error: false,
    loading: false,

    data: null,
  };

  validate = async () => {
    this.setState({ error: false, loading: true });
    try {
      const res = await instance.post("/validate_b2b_profile_password/", {
        slug: this.props.slug,
        password: this.state.password,
      });
      if (res.data.success == true) {
        this.setState({ data: res.data.data });
      } else this.setState({ error: true });
    } catch (err) {
      console.error(err);
      this.setState({ error: true });
    }
    this.setState({ loading: false });
  };

  render() {
    const { b2b, language } = this.props;
    const { password, error, loading } = this.state;
    return (
      <Drawer
        anchor="bottom"
        classes={{
          paperAnchorBottom: language == "arabic" ? "left-auto" : "",
        }}
        open={b2b.profileOpen}
        onClose={() => this.props.setDrawer(false)}
        PaperProps={{
          style: { minHeight: 100, height: "auto", width: "100%" },
          className: "text-center",
        }}
        onBackdropClick={() => this.props.setDrawer(false)}
      >
        <span
          style={{
            position: "absolute",
            padding: 10,
            top: 10,
            [`${language === "arabic" ? "left" : "right"}`]: 10,
          }}
          onClick={() => this.props.setDrawer(false)}
        >
          <CloseIcon />
        </span>

        {!this.state.data ? (
          <Password
            password={password}
            error={error}
            validate={() => this.validate()}
            setPassword={(v) => this.setState({ password: v, error: false })}
            language={language}
            loading={loading}
          />
        ) : (
          <Profile data={this.state.data} slug={this.props.slug} />
        )}
      </Drawer>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    b2b: state.b2b,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDrawer: (state) =>
      dispatch({ type: "SET_B2B_PROFILE_OPEN", payload: state }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(B2BProfile);
